import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";

type PriceQualifyRule = {
  name: string;
  priceMin: number | undefined;
  priceMax: number | undefined;
  alwaysTransfer: boolean;
};

type LeadPriceQualificationRuleCardProps = {
  rule: PriceQualifyRule;
  onRuleChange: (
    field: keyof PriceQualifyRule,
    value: string | number | boolean | undefined
  ) => void;
  onRemove: () => void;
};

const LeadPriceQualificationRuleCard = ({
  rule,
  onRuleChange,
  onRemove,
}: LeadPriceQualificationRuleCardProps) => {
  return (
    <div className="cursor-pointer rounded-md border border-l border-gray-200 bg-white p-4 shadow-sm transition-all duration-200 ease-in-out hover:scale-[1.02] hover:border-l-4 hover:border-l-purple-500 hover:shadow-md">
      <div className="flex items-start justify-between gap-6">
        <div className="flex flex-1 flex-col gap-3">
          <Input
            value={rule.name}
            onChange={(e) => onRuleChange("name", e.target.value)}
            placeholder="Nombre de la regla (ej: Presupuesto Alto)"
            className="border-gray-200 bg-gray-50 font-semibold hover:border-gray-300 hover:bg-white focus-visible:bg-white focus-visible:ring-blue-500"
          />
          <div className="flex gap-3">
            <div className="flex-1">
              <label className="mb-1 block text-xs font-medium text-gray-500">
                Precio Mínimo
              </label>
              <Input
                type="number"
                value={rule.priceMin ?? ""}
                onChange={(e) =>
                  onRuleChange("priceMin", e.target.value ? Number(e.target.value) : undefined)
                }
                placeholder="Sin mínimo"
                className="border-gray-200 bg-gray-50 text-sm hover:border-gray-300 hover:bg-white focus-visible:bg-white focus-visible:ring-blue-500"
              />
            </div>
            <div className="flex-1">
              <label className="mb-1 block text-xs font-medium text-gray-500">
                Precio Máximo
              </label>
              <Input
                type="number"
                value={rule.priceMax ?? ""}
                onChange={(e) =>
                  onRuleChange("priceMax", e.target.value ? Number(e.target.value) : undefined)
                }
                placeholder="Sin máximo"
                className="border-gray-200 bg-gray-50 text-sm hover:border-gray-300 hover:bg-white focus-visible:bg-white focus-visible:ring-blue-500"
              />
            </div>
          </div>
        </div>

        <div className="min-w-[200px]">
          <div className="flex flex-col gap-3">
            <label className="flex items-center gap-2 text-sm">
              <Checkbox
                checked={rule.alwaysTransfer}
                onCheckedChange={(checked) => onRuleChange("alwaysTransfer", !!checked)}
                className="size-3.5"
              />
              <span className="text-xs font-medium text-gray-700">Siempre transferir</span>
            </label>
            <Button
              variant="ghost"
              size="sm"
              onClick={onRemove}
              className="text-xs font-semibold uppercase text-gray-600"
            >
              <Trash2 className="mr-2 size-4" />
              Eliminar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadPriceQualificationRuleCard;
